/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

// Marks a class as available to Injector for creation.
import { Injectable } from '@angular/core';

/* This service is used to emulate the angular-deferred-bootstrap library which fetched the current user from the back-
 * end. In other words, this service is used during the Angular (not AngularJs) bootstrap process, to fetch the current
 * user from the back-end for which we then inject into the auth-service.js file.
*/
@Injectable()
export class BulbFetchUserService {
  private ORIGINAL_USER: any = window.bulbVars ? window.bulbVars.bulbOriginalUser : {};

  constructor() {}

  // Method called when bootstrapping the app to fetch the currently logged in user
  /**
   * Function that fetches the current user from the back-end.
   *
   * @return Promise<any> -- A promise with the fetched current user.
   */
  fetchUser(): Promise< any > {
    return new Promise((resolve, reject) => {
      resolve(this.ORIGINAL_USER);
      reject('Error obtaining original user.');
      // Remove reference to the fetched original bulb user on the window to make sure we use the 'newest'
      // up-to-date user.
      if (window.bulbVars && window.bulbVars.bulbOriginalUser) {
        delete window.bulbVars.bulbOriginalUser;
      }
    });
  }

  get originalUser(): any {
    return this.ORIGINAL_USER;
  }
}
